module.exports = __webpack_public_path__ + "img/loopi-avatar.4d59bbb1.png";